export const getCurrencySymbol = (priceText: string) => {
  try {
    return priceText.replace(/[\d., ]/g, '');
  } catch (error) {
    return '$';
  }
};
